import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {HTTPAssistantRepository} from '../Repositories/HTTPAssistantRepository.js'
import {StartAssistantNewChatRequest} from '../Requests/StartAssistantNewChatRequest.js'

class StartAssistantNewChatUseCase extends UseCase {
  #assistantRepository

  constructor({assistantRepository}) {
    super()
    this.#assistantRepository = assistantRepository
  }

  static create({config}) {
    return new StartAssistantNewChatUseCase({
      assistantRepository: HTTPAssistantRepository.create({config})
    })
  }

  @tracer({metric: 'StartAssistantNewChatUseCase#execute'})
  @AsyncInlineError()
  async execute({text, context, variant}) {
    const startAssistantNewChatRequest = StartAssistantNewChatRequest.create({text, context})
    const [error, response] = await this.#assistantRepository.startNewChat({startAssistantNewChatRequest, variant})
    if (error) return Promise.reject(error)
    return response?.toJSON?.()
  }
}

export const factory = StartAssistantNewChatUseCase.create
